<template>
	<div class="container">
		<van-nav-bar class="custom-nav-bar" :title="$t('about.title')">
			<template #left>
				<div style="width: 86px; height: 32px; margin-left: 15px;" @click="back()">
					<div class="nav-bar__back">
						<span class="tn-icon-left-arrow"></span>
					</div>
				</div>
			</template>
		</van-nav-bar>

		<div class="content-section">
			<div class="content-container">
				<p>
					{{ $t('about.content') }}
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				o_new_password: "",
				t_new_password: "",
				old_password: "",
				userInfo: {}
			};
		},
		methods: {
			back() {
				return window.history.back();
			},
			save() {
				if (this.o_new_password === "" || this.o_new_password === null || this.o_new_password === undefined) {
					this.$toast.fail(this.$t("setting.prefect"));
					return false;
				}
				if (this.t_new_password === "" || this.t_new_password === null || this.t_new_password === undefined) {
					this.$toast.fail(this.$t("setting.prefect"));
					return false;
				}
				if (this.old_password === "" || this.old_password === null || this.old_password === undefined) {
					this.$toast.fail(this.$t("setting.prefect"));
					return false;
				}
				if (this.o_new_password !== this.t_new_password) {
					this.$toast(this.$t("setting.pwd_error"));
					return false;
				}
				this.$http({
					method: 'get',
					data: {
						old_password: this.old_password,
						new_password: this.o_new_password,
					},
					url: 'user_set_loginpw'
				}).then(res => {
					if (res.code === 200) {
						this.$toast(res.msg);
						setTimeout(() => {
							localStorage.clear()
							this.$router.push("Login")
						}, 500);

					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			},
			getUserInfo() {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code === 200) {
						this.userInfo = res.data;
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			}
		},
		created() {
			if (!localStorage.getItem('token')) {
				this.$router.push({
					path: '/Login'
				})
			} else {
				this.getUserInfo();
			}
		}
	};
</script>

<style lang='less' scoped>
	.custom-nav-bar {
		height: 45px;
		position: fixed;
		z-index: 999;
		display: block;
		position: relative;
		line-height: normal;
	}

	::v-deep .van-nav-bar__content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		min-height: 0;
		height: 45px;
		padding-top: 0px;
		background-color: rgb(255, 255, 255);
		z-index: 29090;
		box-shadow: 0px 0px 41px 0px rgba(0, 0, 0, .05);
		position: fixed;
		width: 100%;
		top: 0;
	}

	::v-deep .van-nav-bar__left {
		padding: 0;
	}

	::v-deep .van-nav-bar__title {
		color: #000 !important;
		font-size: 18px;
		font-weight: 700;
		top: 0px;
		height: 45px;
		line-height: 45px;
		width: calc(100% - 202px);
		position: absolute;
		text-align: center;
		left: 0;
		right: 0;
		bottom: 0;
		cursor: none;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.nav-bar__back {
		width: 31px;
		height: 31px;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;
		background-color: rgba(0, 0, 0, .05);
		border-radius: 50%;
		color: #333;
		font-size: 14px;
	}

	/* 页面背景 */
	.container {
		background-color: #f5f5f5;
		height: 100vh
	}

	/* 内容区域 */
	.content-section {
		padding: 20px 10px;
		height: 100vh;
		overflow-y: scroll
	}

	/* 内容容器 */
	.content-container {
		background: #fff;
		border-radius: 8px;
		padding: 15px;
		box-shadow: 0 1px 6px rgba(0, 0, 0, .08)
	}

	.content-container h1,
	.content-container h2,
	.content-container h3 {
		color: #333;
		margin-bottom: 10px
	}

	.content-container p {
		color: #666;
		line-height: 1.6;
		margin-bottom: 8px
	}

	.content-container ul,
	.content-container ol {
		margin-left: 20px;
		margin-bottom: 8px
	}

	.content-container ul li,
	.content-container ol li {
		color: #666;
		line-height: 1.5;
		margin-bottom: 4px
	}

	/* 导航栏返回按钮 */
	.tn-custom-nav-bar__back {
		width: 31px;
		height: 31px;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;
		background-color: rgba(0, 0, 0, .05);
		border-radius: 50%;
		color: #333;
		font-size: 14px
	}

	.tn-custom-nav-bar__back .icon {
		display: block
	}
</style>
